import BannerCategoryContainer from './BannerCategoryContainer';

export default BannerCategoryContainer;
